export default [{ enabled: true, featureId: 'newTDeskUI' }];
